import type { RouterConfig } from "@nuxt/schema";
import { bibleRouteNameRegex } from "~/routing/regex";

export default <RouterConfig>{
  routes: (originalRoutes) => {
    return [
      {
        name: "root",
        path: "/",
        component: () =>
          import("~/extra-pages/rootPage.vue").then((r) => r.default || r),
      },
      ...originalRoutes,
    ];
  },
};
